/* =============================================================
 * import
 * ========================================================== */
import {mediaQuery} from '../utils/utils';
import {tableScrollHint} from "../modules/scrollHint";


/* =============================================================
 * function
 * ========================================================== */

export default function exe() {
  tableScrollHint();  // 大きいテーブルの横スクロール化

  // slideDownBtn();

  window.addEventListener('resize', function() {
    if (mediaQuery() !== 'sp') {
      // slideDownBtn();
    }
  });

  window.addEventListener("orientationchange", function() {
    if (mediaQuery() !== 'sp') {
      // slideDownBtn();
    }
  });
}
